import { render, staticRenderFns } from "./Barcharts.vue?vue&type=template&id=42703668&"
import script from "./Barcharts.vue?vue&type=script&lang=js&"
export * from "./Barcharts.vue?vue&type=script&lang=js&"
import style0 from "./Barcharts.vue?vue&type=style&index=0&id=42703668&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/dashboard/Barcharts.vue
// module id = 1279
// module chunks = 0